import { get, post, put, del } from '../../utils/http';

export type AiRule = {
  id: string;
  name?: string;
  content: string;
  created_at: string;
  updated_at: string;
};

export type AiRulesResponse = {
  rules: AiRule[];
};

export type CreateAiRuleRequest = {
  name?: string;
  content: string;
};

export type UpdateAiRuleRequest = {
  name?: string;
  content: string;
};

export const fetchAiRules = (): Promise<AiRulesResponse> =>
  get(`${window.VITE_API_BASE_URL}/account/ai-rules/`);

export const createAiRule = (data: CreateAiRuleRequest): Promise<AiRule> =>
  post(`${window.VITE_API_BASE_URL}/account/ai-rules/`, data);

export const updateAiRule = (
  ruleId: string,
  data: UpdateAiRuleRequest,
): Promise<AiRule> =>
  put(`${window.VITE_API_BASE_URL}/account/ai-rules/${ruleId}`, data);

export const deleteAiRule = (ruleId: string): Promise<void> =>
  del(`${window.VITE_API_BASE_URL}/account/ai-rules/${ruleId}`);
